import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-ink px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <p className="font-serif text-3xl font-semibold text-white">KIS Living<span className="text-terracotta">.</span></p>
          <p className="text-white/50 text-sm mt-2">Admin Console</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-xl">
          <div className="flex items-center gap-2 mb-6 text-ink">
            <Lock size={18} className="text-terracotta" />
            <h1 className="font-serif text-2xl font-semibold">Sign in</h1>
          </div>
          {error && (
            <div data-testid="admin-login-error" className="mb-4 text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <div className="flex flex-col gap-2 mb-4">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="admin-login-email" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="admin@kisliving.com"
              className="h-11 rounded-xl border-bone focus-visible:ring-terracotta" />
          </div>
          <div className="flex flex-col gap-2 mb-6">
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="admin-login-password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="h-11 rounded-xl border-bone focus-visible:ring-terracotta" />
          </div>
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full h-11 rounded-xl bg-terracotta hover:bg-terracotta-hover text-white">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
